import React from 'react'
import Navbar from '../Components/Ui/Navbar'
import Banner from '../Components/Sections/Home/Banner'
import Products from '../Components/Sections/Home/Products'
import DetailProduct from '../Components/Sections/Home/DetailProduct'
import Formulario from '../Components/Sections/Home/Formulario'

import { Form } from 'antd'
import Footer from '../Components/Ui/Footer'

function Home() {

    const [form] = Form.useForm();

    return (
        <>
            <Navbar />
            <Banner />
            <Products form={form} />
            <DetailProduct />
            <Formulario form={form} />
            <Footer />
        </>
    )
}

export default Home